/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Button, Grid, GridItem, useToast } from '@chakra-ui/react'
import { ModalBuildHandle } from 'components/molecules/ModalBuild/interfaces'
import { TableBuild } from 'components/organisms'
import { ConfirmationModal } from 'components/organisms/ConfirmationModal/ConfirmationModal'
import { TableBuildProps } from 'components/organisms/TableBuild/interfaces'
import { QueryDTO } from 'models'
import React, { useEffect, useRef, useState } from 'react'
import { deleteAddress } from 'services/address'
import { ModalAddress } from './ModalAddress'
import { AddressProps } from './interfaces'
import { AddressKeys } from './types'

const Address: React.FC<AddressProps> = ({ initial, fetchInstitution }) => {
    const [loading, setLoading] = useState(false)
    const [searching, setSearching] = useState<boolean>(false)
    const [itemEdit, setItemEdit] = useState<any>()
    const [itemRemove, setItemRemove] = useState<any>()
    const [page, setPage] = useState<number>(1)
    const [limit, setLimit] = useState(10)
    const [totalPages, setTotalPages] = useState(1)
    const [orderBy, setOrderBy] = useState<
        Required<Pick<QueryDTO<'logradouro'>, 'ordenacao' | 'tipoOrdenacao'>>
    >({
        ordenacao: 'logradouro',
        tipoOrdenacao: 'ASC'
    })

    const refModalAddress = useRef<ModalBuildHandle>(null)

    const handleOpenModal = (): void => {
        refModalAddress.current?.onOpen()
    }

    const handleClose = async (callbackGet = false) => {
        setItemEdit({})

        if (callbackGet) {
            fetchInstitution()
        }

        refModalAddress.current?.onClose()
    }

    const deleteModalRef = useRef<ModalBuildHandle>(null)
    const toast = useToast()

    function emitToastError(error: any) {
        const message =
            error?.response?.data[0]?.mensagem ??
            'Algo deu errado, tente novamente mais tarde.'

        toast({
            title: `Falha ao Remover Endereço`,
            description: message,
            position: 'bottom-left',
            status: 'error',
            isClosable: true
        })
    }

    function emitToastSuccess() {
        toast({
            title: `Endereço`,
            description: `O endereço foi removido com sucesso!`,
            position: 'bottom-left',
            status: 'success',
            isClosable: true
        })
    }

    const handleDeleteItem = async () => {
        try {
            await deleteAddress(initial.id, itemRemove)
            emitToastSuccess()
            const updatedList = table.body?.filter(row => row.id !== itemRemove)
            if (updatedList) {
                setTable(old => ({
                    ...old,
                    body: updatedList
                }))
            }
        } catch (error) {
            emitToastError(error)
        }
    }

    const handleConfirm = () => {
        handleDeleteItem()
        handleCloseDeleteModal()
    }

    const handleCancel = () => {
        handleCloseDeleteModal()
    }

    const handleOpenDeleteModal = (): void => {
        deleteModalRef.current?.onOpen()
    }

    const handleCloseDeleteModal = (): void => {
        deleteModalRef.current?.onClose()
    }

    const [table, setTable] = useState<
        TableBuildProps<
            Extract<
                AddressKeys,
                'tipoEndereco' | 'cep' | 'logradouro' | 'uf' | 'municipio'
            >
        >
    >({
        header: [
            {
                name: 'tipoEndereco',
                text: 'Tipo de endereço',
                position: 0
            },
            {
                name: 'cep',
                text: 'CEP',
                position: 1
            },
            {
                name: 'logradouro',
                text: 'Logradouro',
                position: 2
            },
            {
                name: 'uf',
                text: 'UF',
                position: 3
            },
            {
                name: 'municipio',
                text: 'Cidade',
                position: 4
            }
        ],
        action: [
            {
                type: 'EDIT'
            },
            {
                type: 'DELETE'
            }
        ]
    })

    const handlePage = (value: number) => {
        setPage(value)
    }

    const handleLimit = (value: number) => {
        setLimit(value)
    }

    const handleAction = (typeAction: string, id: number | string) => {
        const item =
            table.body?.length && table.body.find(item => item.id === id)

        switch (typeAction) {
            case 'EDIT':
                setItemEdit(item)
                handleOpenModal()
                break

            case 'DELETE':
                handleOpenDeleteModal()
                setItemRemove(id)
                break
        }
    }

    useEffect(() => {
        setTable(old => ({
            ...old,
            body: initial.enderecos
        }))
    }, [initial])

    return (
        <>
            <Grid
                templateColumns={{ base: '1fr', sm: 'repeat(2, auto)' }}
                textAlign="end"
                alignItems="center"
                justifyContent="space-between"
                gap={{ base: 4, md: 6 }}
                px={6}
                py={4}
                mb={4}
            >
                <GridItem w="100%">
                    {/* <InputGroup w="100%">
                        <Input
                            minW={{ md: '400px' }}
                            id="search"
                            variant="flushed"
                            placeholder="Buscar por tipo de endereço, CEP ou logradouro"
                        />
                        <InputRightElement
                            as="label"
                            htmlFor="search"
                            children={<Icon name="search" />}
                        />
                    </InputGroup> */}
                </GridItem>
                <GridItem w="100%">
                    <Button onClick={handleOpenModal} colorScheme="primary">
                        Novo endereço
                    </Button>
                </GridItem>
            </Grid>

            <TableBuild
                header={table.header}
                body={table.body}
                ordenation={orderBy}
                action={table.action}
                error={{
                    action: {
                        text: 'institution',
                        custom: 'Nenhum endereço cadastrado'
                    }
                }}
                onAction={handleAction}
                loading={{
                    status: loading,
                    loader: [
                        {
                            height: '20px'
                        },
                        {
                            height: '20px'
                        },
                        {
                            height: '20px'
                        }
                    ]
                }}
                pagination={{
                    limit,
                    page,
                    totalPages
                }}
                onChangeLimit={handleLimit}
                onChangePage={handlePage}
            />

            <ModalAddress
                setSearching={setSearching}
                searching={searching}
                handleClose={handleClose}
                itemEdit={itemEdit}
                refModal={refModalAddress}
                institution={initial}
                setItemEdit={setItemEdit}
            />
            <ConfirmationModal
                handleCancel={handleCancel}
                handleConfirm={handleConfirm}
                refModal={deleteModalRef}
            />
        </>
    )
}

export default Address
